export enum AdditionalDocumentType {
  ProofIdentityFront = 0,
  ProofAddressFront = 1,
  ProofIdentityBack = 2,
  ProofAddressBack = 3,
  ProofAddressAdditional = 4,
}
